import { BaseRouteConfig as RouteConfig } from '../alliance-layout';
import { IMenu } from '../side-menu';

export type Routers = Array<RouteConfig>;

const BaseLayout = (props: any) => props.children;

export const normalizeRouter = (configs: Routers): RouteConfig[] =>
  configs?.map(router => {
    const computedRouter = router;
    if (!router.path) {
      throw new Error(`router ${router.path} must have path`);
    }
    if (computedRouter.children) {
      const subConfig: Routers = computedRouter.children;
      computedRouter.children = normalizeRouter(subConfig);
    }
    return {
      ...computedRouter,
      path: router.path,
      component: router.component || BaseLayout,
    } as RouteConfig;
  });

type MenuIcon = { active: JSX.Element; default: JSX.Element };
export const routeToMenu = (routes: Routers): IMenu[] => {
  const menus: IMenu[] = [];
  routes.forEach(r => {
    const name = typeof r.name === 'function' ? r.name() : r.name;
    if (!name && r.children?.length) {
      menus.push(...routeToMenu(r.children));
    }
    let icon: MenuIcon;
    if (r.icon && (r.icon as MenuIcon)?.active) {
      icon = r.icon as MenuIcon;
    } else {
      icon = {
        active: r.icon as JSX.Element,
        default: r.icon as JSX.Element,
      };
    }
    if (name) {
      menus.push({
        key: r.path,
        title: name || '',
        show: Boolean(name),
        url: r.path,
        children: r.children?.length ? routeToMenu(r.children) : undefined,
        icon,
        pageName: r.pageName,
        useOverflowTooltip: r.useOverflowTooltip,
      });
    }
  });
  return menus;
};

export const getRouteByPath = (
  routes: RouteConfig[],
  path: string,
  exact = true,
): RouteConfig | undefined => {
  const recursiveMatch = (currentRoutes: RouteConfig[]) => {
    let maxLen = 0;
    let matchedRoute: RouteConfig | undefined;

    for (const route of currentRoutes) {
      const { path: routePath } = route;
      const pattern = routePath.replaceAll(/:[^/]+/g, '[^/]+');
      const routePathRegex = new RegExp(`^${pattern}`);
      const exactPathRegex = new RegExp(`^${pattern}$`);
      if (exact && !route.external) {
        if (exactPathRegex.test(path)) {
          return { maxLen: path.length, matchedRoute: route };
        }
      } else if (!route.children && routePathRegex.test(path)) {
        // when exact is false, match route which is leaf node and is subset of path
        //* get the routePath which has the longest common prefix
        if (routePath.length > maxLen) {
          maxLen = routePath.length;
          matchedRoute = route;
        }
      }

      if (route.children) {
        const { matchedRoute: childRoute, maxLen: childMaxLen } =
          recursiveMatch(route.children);
        if (childRoute && childMaxLen > maxLen) {
          matchedRoute = childRoute;
          maxLen = childMaxLen;
        }
      }
    }

    return { maxLen, matchedRoute };
  };

  const { matchedRoute } = recursiveMatch(routes);

  return matchedRoute;
};
